import React, { useEffect, useState, useRef } from "react";
import "./StatsSection.css";

const STATS_DATA = [
  {
    target: 29,
    suffix: "+",
    label: "Years Experience",
    index: "01",
    caption: "Market Presence",
  },
  {
    target: 300,
    suffix: "T",
    label: "Annual Capacity",
    index: "02",
    caption: "Production Output",
  },
  {
    target: 50,
    suffix: "+",
    label: "Major Clients",
    index: "03",
    caption: "Enterprise Partners",
  },
  {
    target: 100,
    suffix: "%",
    label: "Quality Assured",
    index: "04",
    caption: "Defect-Free Guarantee",
  },
];

function StatCard({ target, suffix, label, index, caption }) {
  const [count, setCount] = useState(0);
  const cardRef = useRef(null);
  const hasAnimated = useRef(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !hasAnimated.current) {
          hasAnimated.current = true;
          // let start = 0;
          const duration = 1500; // Animation duration in ms
          const startTime = performance.now();

          const animate = (now) => {
            const progress = Math.min((now - startTime) / duration, 1);
            // Ease out quad formula for smooth decelerating animation
            const easeProgress = progress * (2 - progress);

            setCount(Math.floor(easeProgress * target));

            if (progress < 1) {
              requestAnimationFrame(animate);
            } else {
              setCount(target);
            }
          };

          requestAnimationFrame(animate);
        }
      },
      { threshold: 0.1 },
    );

    if (cardRef.current) observer.observe(cardRef.current);
    return () => observer.disconnect();
  }, [target]);

  return (
    <div className="gz-stat-card" ref={cardRef}>
      <div className="gz-card-header">
        <span className="gz-card-index">{index}</span>
        <span className="gz-card-dot" />
      </div>
      <div className="gz-card-body">
        <div className="gz-stat-display">
          <span className="gz-stat-value">{count}</span>
          <span className="gz-stat-suffix">{suffix}</span>
        </div>
        <h3 className="gz-stat-label">{label}</h3>
        <p className="gz-stat-caption">{caption}</p>
      </div>
    </div>
  );
}

export default function StatsSection() {
  return (
    <section className="gz-stats-section">
      <div className="gz-stats-container">
        {STATS_DATA.map((stat, idx) => (
          <StatCard key={idx} {...stat} />
        ))}
      </div>
    </section>
  );
}
